var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stepsInventario"},[_c('el-steps',{attrs:{"active":_vm.step}},_vm._l((_vm.steps),function(s,i){return _c('el-step',{key:i,attrs:{"title":_vm.$t(("Paso " + (i+1))),"description":_vm.$t(s)}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }